import { HypervoltCableLength, HypervoltBaseColour } from "_core/types/charger";
import {
  PRICE_HYPERVOLT_10M,
  PRICE_HYPERVOLT_5M,
  PRICE_HYPERVOLT_7_5M,
} from "_core/config/prices";

export const HYPERVOLT_CABLES: {
  value: HypervoltCableLength;
  label: string;
  price: number;
}[] = [
  {
    label: "5m cable",
    price: PRICE_HYPERVOLT_5M,
    value: "5m",
  },
  {
    label: "7.5m cable",
    price: PRICE_HYPERVOLT_7_5M,
    value: "7.5m",
  },
  {
    label: "10m cable",
    price: PRICE_HYPERVOLT_10M,
    value: "10m",
  },
];

export const HYPERVOLT_COLOURS: {
  value: HypervoltBaseColour;
  label: string;
}[] = [
  {
    value: "ultraWhite",
    label: "Ultra White",
  },
  {
    value: "spaceGrey",
    label: "Space Grey",
  },
  {
    value: "ultraBlack",
    label: "Ultra Black",
  },
];
